module.exports = __webpack_public_path__ + "img/processo_digital.eb5fb728.png";